import React, { useState } from "react";
import { Modal, Button, Badge } from "react-bootstrap";
import {
    FaCalendarAlt, FaUsers, FaStore, FaFileInvoice,
    FaClipboardCheck, FaMapMarkerAlt, FaPhone
} from "react-icons/fa";

const PatrolActivityModal = ({ show, onHide, data }) => {
    const [viewType, setViewType] = useState('establishments'); // النوع المعروض حالياً

    if (!data) return null;

    const { roster, members, totals, establishments, inspectionVisits, violationReports } = data;

    // دالة مساعدة لتغيير القسم المعروض
    const renderDetailSection = () => {
        switch (viewType) {
            case 'establishments':
                return (
                    <div className="detail-list animate-fade">
                        <h6 className="border-bottom pb-2 mb-3 text-primary"><FaStore className="ms-2" />الفعاليات المضافة ({establishments.length})</h6>
                        {establishments.map(est => (
                            <div key={est.establishmentId} className="item-card shadow-sm p-3 mb-2 rounded border-end border-primary border-3">
                                <div className="d-flex justify-content-between">
                                    <strong className="text-dark">{est.name}</strong>
                                    <small className="text-muted"><FaMapMarkerAlt className="ms-1" /> {est.district}</small>
                                </div>
                                <div className="text-muted x-small mt-1">
                                    <FaPhone className="ms-1" /> {est.phone} | {est.addressText}
                                </div>
                            </div>
                        ))}
                    </div>
                );
            case 'visits':
                return (
                    <div className="detail-list animate-fade">
                        <h6 className="border-bottom pb-2 mb-3 text-info"><FaClipboardCheck className="ms-2" />الزيارات المنفذة ({inspectionVisits.length})</h6>
                        {inspectionVisits.length === 0 ? <p className="text-center text-muted">لا يوجد زيارات مسجلة</p> : null}
                    </div>
                );
            case 'violations':
                return (
                    <div className="detail-list animate-fade">
                        <h6 className="border-bottom pb-2 mb-3 text-danger"><FaFileInvoice className="ms-2" />الضبوط المنظمة ({violationReports.length})</h6>
                        {violationReports.length === 0 ? <p className="text-center text-muted">لا يوجد ضبوط منظمة</p> : null}
                    </div>
                );
            default: return null;
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered dir="rtl">
            <Modal.Header closeButton className="bg-light">
                <Modal.Title className="fs-5 fw-bold text-dark">
                    <FaCalendarAlt className="ms-2 text-primary" /> سجل نشاط الدورية: {roster.username}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                {/* الجزء العلوي: معلومات عامة */}
                <div className="roster-info-header d-flex justify-content-between align-items-center mb-4 p-3 bg-primary bg-opacity-10 rounded-3">
                    <div>
                        <div className="fw-bold"><FaUsers className="ms-1" /> أعضاء الدورية:</div>
                        <div className="small">
                            {members.map(m => m.fullName).join(" - ")}
                        </div>
                    </div>
                    <div className="text-start">
                        <Badge bg="primary" className="p-2 px-3">
                            <FaCalendarAlt className="ms-1" /> {roster.patrolDate}
                        </Badge>
                    </div>
                </div>

                {/* مربعات الإحصائيات التفاعلية */}
                <div className="row g-3 mb-4">
                    <div className="col-md-4" onClick={() => setViewType('establishments')}>
                        <div className={`stat-box text-center p-3 rounded-4 cursor-pointer transition ${viewType === 'establishments' ? 'active-est shadow' : 'bg-light'}`}>
                            <FaStore className="fs-3 mb-2 text-primary" />
                            <h4 className="fw-bold mb-0">{totals.establishments}</h4>
                            <div className="text-muted small">فعاليات مضافة</div>
                        </div>
                    </div>
                    <div className="col-md-4" onClick={() => setViewType('visits')}>
                        <div className={`stat-box text-center p-3 rounded-4 cursor-pointer transition ${viewType === 'visits' ? 'active-visit shadow' : 'bg-light'}`}>
                            <FaClipboardCheck className="fs-3 mb-2 text-info" />
                            <h4 className="fw-bold mb-0">{totals.inspectionVisits}</h4>
                            <div className="text-muted small">زيارات تفتيشية</div>
                        </div>
                    </div>
                    <div className="col-md-4" onClick={() => setViewType('violations')}>
                        <div className={`stat-box text-center p-3 rounded-4 cursor-pointer transition ${viewType === 'violations' ? 'active-violation shadow' : 'bg-light'}`}>
                            <FaFileInvoice className="fs-3 mb-2 text-danger" />
                            <h4 className="fw-bold mb-0">{totals.violationReports}</h4>
                            <div className="text-muted small">ضبوط منظمة</div>
                        </div>
                    </div>
                </div>

                {/* قسم التفاصيل المتحرك */}
                <div className="details-container p-2">
                    {renderDetailSection()}
                </div>
            </Modal.Body>
            <Modal.Footer className="bg-light">
                <Button variant="secondary" onClick={onHide}>إغلاق</Button>
            </Modal.Footer>

            <style>{`
                .cursor-pointer { cursor: pointer; }
                .stat-box { border: 2px solid transparent; transition: all 0.3s ease; }
                .stat-box:hover { transform: translateY(-3px); }
                .active-est { background: #fff; border-color: #0d6efd; color: #0d6efd; }
                .active-visit { background: #fff; border-color: #0dcaf0; color: #0dcaf0; }
                .active-violation { background: #fff; border-color: #dc3545; color: #dc3545; }
                .item-card { background: #fff; transition: background 0.2s; }
                .item-card:hover { background: #f8f9fa; }
                .x-small { font-size: 0.75rem; }
                .animate-fade { animation: fadeIn 0.4s ease-in; }
                @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
            `}</style>
        </Modal>
    );
};

export default PatrolActivityModal;